import { Injectable, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    GetLegitimationDto, GetUserProfileDataDto, MySironaLegitimationServiceProxy, MySironaUserServiceProxy } from '@shared/service-proxies/service-proxies';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class UserService extends AppComponentBase {
    identificationStatus: string;

    constructor(
        injector: Injector,
        private readonly mySironaUserService: MySironaUserServiceProxy,
        private readonly mySironaLegitimationService: MySironaLegitimationServiceProxy
    ) {
        super(injector);
    }

    getUserProfileData(): Observable<GetUserProfileDataDto> {
        return this.mySironaUserService.getUserProfileData();
    }

    getIdentificationStatus(refresh = false): Observable<string> {
        if (!refresh && this.identificationStatus) {
            return of(this.identificationStatus);
        }

        return this.mySironaUserService.getIdentificationStatus()
            .pipe(tap(x => this.identificationStatus = x));
    }

    getLegitimations(): Observable<GetLegitimationDto[]> {
        return this.mySironaLegitimationService.getLegitimations();
    }
}
